module.exports = __webpack_public_path__ + "media/img/plane-20c6f22f.svg";